import {
  BreakStyle,
  defineStylesWithBreaks,
  lineClampStyle,
  useMouseover,
  useThemedStylesWithBreaks
} from 'notability-services-common-frontend'

import {useCustomRouter} from '../util/useCustomRouter'
import {AvatarCircle} from './AvatarCircle'

interface DrillDownUserProfileArgs {
  screenname: string
  avatarUrl?: string
  linksToProfile: boolean
}

const container = {
  display: 'flex',
  alignItems: 'center',
  flexGrow: 999,
  margin: '8px 0px 8px 0px'
}

const avatarDrillDownNote = {
  height: '24px',
  width: '24px',
  marginTop: 0,
  marginBottom: 0,
  marginRight: '6px',
  marginLeft: 0,
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '24px'
}

const styles = defineStylesWithBreaks((theme) => {
  const hover: BreakStyle = {
    textDecoration: 'underline'
  }

  const username: BreakStyle = {
    fontSize: '15px',
    fontStyle: 'normal',
    fontWeight: 600,
    maxWidth: '25vw',
    ...lineClampStyle(1),
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
    lineHeight: '20px',
    md: {
      maxWidth: '65vw'
    },
    mobile: {
      maxWidth: '65vw'
    }
  }

  return {
    username,
    usernameHover: {...username, ...hover},
    usernameBold: {
      ...username,
      fontWeight: 700
    }
  }
})

export default function DrillDownUserProfile({screenname, avatarUrl, linksToProfile}: DrillDownUserProfileArgs) {
  const router = useCustomRouter()
  const s = useThemedStylesWithBreaks(styles)
  const [isMouseOver, mouseEvents] = useMouseover()

  return (
    <div
      {...(linksToProfile ? mouseEvents : {})}
      style={{...container, cursor: linksToProfile ? 'pointer' : 'default'}}
      onClick={linksToProfile ? () => router.pushProfile({screenname}) : undefined}
    >
      <AvatarCircle style={avatarDrillDownNote} screenname={screenname} avatarUrl={avatarUrl} isHovered={isMouseOver} />
      <div style={isMouseOver ? s.usernameHover : s.username}>{screenname}</div>
    </div>
  )
}
